/** @jsx jsx */
import React, { useMemo, useState } from 'react';
import { css, jsx } from '@emotion/react';
import { InstructionsPage } from '../interfaces/model';
import { Modal } from 'antd';
import getConfig from "../../config"
import './view-instructions.css'
import { Button } from '../button';
import { AIcon as Icon } from '../icon';

export const ViewInstructionsComponent: React.FC<{
  instructions: InstructionsPage[],
  visible?: boolean,
  onClose?: () => void,
}> = props => {
  const { instructions, visible, onClose } = props;

  const [currentPage, setCurrentPage] = useState<number>(0);
  // TODO: currently hard-coded for max of 4 images, which is only ensured by client-side requirement in edit-instructions form
  const [imagesLoaded, setImagesLoaded] = useState<boolean[]>([false, false, false, false]);
  const [currentImage, setCurrentImage] = useState(0);

  const page = useMemo(() => instructions[currentPage], [instructions, currentPage]);

  const images = useMemo<string[]>(() => page.images ? page.images.map(img => `${getConfig().model_photos}${img}`) : [],
    [page]);

  const modalFooter = useMemo(() => {
    const pageBack = () => {
      setCurrentPage(currentPage - 1);
      setCurrentImage(0);
    };

    const backEnabled = currentPage > 0;

    const onLastPage = (instructions && (currentPage >= (instructions.length - 1)));
    const pageForward = () => {
      if (!onLastPage) {
        setCurrentPage(currentPage + 1);
        setCurrentImage(0);
      } else {
        onClose && onClose();
      }
    }
    const nextTitle = onLastPage ? 'Continue' : 'Next';

    const buttons = [<Button key="back" onClick={pageBack} disabled={!backEnabled} outline title='Back' />];
    buttons.push(<Button key="next" onClick={pageForward} title={nextTitle} />);
    return buttons;
  }, [page, currentPage, instructions]);

  return <Modal
    open={visible}
    title={page.title || ''}
    footer={modalFooter}
    afterClose={() => setCurrentPage(0)}
    onCancel={() => onClose && onClose()}
  >
    <div className='image-wrapper'>
      <div className={`inst-image-container${imagesLoaded[currentImage] ? ' inst-image-container-loaded' : ''}`}>
        <img src={images[currentImage]} onLoad={(() => {
          const newImagesLoaded = [...imagesLoaded];
          newImagesLoaded[currentImage] = true;
          setImagesLoaded(newImagesLoaded);
        })} />
        {!imagesLoaded[currentImage] && <Icon type="loading" />}
      </div>
    </div>
    {(images.length > 1) && <div className='image-chooser'>
      {images.map((img, i) => <img
        className={`image-thumbnail${(i === currentImage ? ' image-thumbnail-selected' : '')}`}
        onClick={() => setCurrentImage(i)}
        src={img} />)}
    </div>}
    {page.body || <div css={css(`font-style: italic;`)}>No description provided</div>}
  </Modal>
};